import ListCache from "./component-library439.mjs";
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
export {
  stackClear as default
};
